import { render, staticRenderFns } from "./Cardtag.vue?vue&type=template&id=9d79332a&"
import script from "./Cardtag.vue?vue&type=script&lang=js&"
export * from "./Cardtag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports